import cookie from './cookie';
import cpArgExportPrivacyPolicy from './cpArgExportPrivacyPolicy';
import error from './error';
import excel from './excel';
import helper from './helper';
import localStorage from './localStorage';
import loginHandle from './loginHandle';
import message from './message';
import pinyin from './pinyin';
import request from './request';
import sessionStorage from './sessionStorage';
import testTestTest from './test/test/test';

export default {
    cookie,
    cpArgExportPrivacyPolicy,
    error,
    excel,
    helper,
    localStorage,
    loginHandle,
    message,
    pinyin,
    request,
    sessionStorage,
    testTestTest
}



// WEBPACK FOOTER //
// ./website/helper/autoload.js